import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'account/api/v1/account-ownerships';

const store = coreStore.createCoreStore('accountOwnership', remoteResource);

store.state.supportedPartyRoleIds = []

store.mutations.setSupportedPartyRoleIds = function(state, ids) {
    state.supportedPartyRoleIds = ids;
}

store.actions.refreshSupportedPartyRoleIds = function({commit, state}) {
    Axios.get(`${remoteResource}/supported-ownership-party-role-type-ids`).then(res => res.data)
        .then(res => commit("setSupportedPartyRoleIds", res))
}

store.getters.supportedPartyRoleIds = (state) => state.supportedPartyRoleIds ;

export default store;
